import React, { useContext, useEffect, useState } from 'react'
import axios from "axios"
import { context } from './ContextFun'
import FlipMove from 'react-flip-move';
import useLocalStorage from 'use-local-storage';
import Loading from "./loading.gif"


function Todo() {
  let [inputValue, setInputValue] = useState({ value: "", isColored: false })
  

    // let[todos,setTodos] = useState([]) here will be the findUser array
  let { value, setValue, users, setUsers,loadData,isLoading } = useContext(context)
  
let findUser = users.find(user => user.email === value.email)
  // let [signedinUser, setSignedinUser] = useLocalStorage("Signed-in-user",findUser)
  let [signedinUser, setSignedinUser] = useState(findUser)

  console.log("Signed in User", signedinUser);

  
  console.log("users", users);
 



  useEffect(() => {
    // let findUser = users.find(user => user.email === value.email)
    setSignedinUser(findUser)
  }, [users])
  
  // useEffect(() => {
  //   loadData()
  // },[])
 


  let handleAdd =  (e) => {
    e.preventDefault()
    // let newTodoList =  signedinUser.todoList.push(inputValue) //! This is easy way
    // setSignedinUser({ ...signedinUser, newTodoList }) //! This is easy way
    setSignedinUser({ ...signedinUser, todoList: [...signedinUser.todoList, inputValue] }) //! this is for the layout 
    
    axios.put(`https://backend-todolist.vercel.app/users/${signedinUser._id}`, { ...signedinUser, todoList: [...signedinUser.todoList, inputValue] } ) //! this is for the backend and layout but for layout u need to go and signin again to see the changes
    setInputValue({value:"",isColored:false})
  }
  
  let handleDelete =  (i) => {
    let filterd = signedinUser.todoList.filter((item, index) => index !== i)
     axios.put(`https://backend-todolist.vercel.app/users/${signedinUser._id}`, {...signedinUser,todoList:filterd})
    setSignedinUser({...signedinUser,todoList:filterd})
  }


  let handleDone = (i) => {
    let done = signedinUser.todoList.map((item, index) => index === i ? { ...item, isColored: !item.isColored } : item)
    // axios.put(`http://localhost:4000/users/${signedinUser._id}`,{...signedinUser,todoList:done})
    setSignedinUser({...signedinUser,todoList:done})
  }

 
  





  return (
    <div className='todo'>

{isLoading && (
        <div className="loading">
        <img src={Loading} alt="" />
        </div>
      )}

      { <h1>Hello { signedinUser?.username[0].toUpperCase() + signedinUser?.username.slice(1)}, Welcome to your To do List</h1>}
          <form onSubmit={handleAdd} action="">
              <input required value={inputValue.value} onChange={(e)=>setInputValue({...inputValue,value:e.target.value})} placeholder='Add...' type="text" name="text" id="" />
        <button>Add</button>
          </form>

     
     <ul className='todosLists'>
        <FlipMove>
        {signedinUser?.todoList.map((item,i) => (<li>
          <span className={item.isColored && "done"}>{item.value}</span>
          <div className="btns">
          <button onClick={()=>handleDelete(i)}>Delete</button>
            <button onClick={()=>handleDone(i)}>Done</button>
          </div></li>))}

        </FlipMove>
     </ul>
          

    </div>
  )
}

export default Todo